import { buildPhaseService, type TaskSelectionPromptResponse } from '../../services/buildPhaseService';
import { eventService } from '../../services/eventService';

import { scheduleTaskSelectionActionReveal } from './taskSelectionActionReveal';
import { createActionInvocationId } from './useActionBarClicks';

/**
 * Ask the server to place the current phase selector at the end of chat.
 * The server owns latest-bubble deduplication and durable persistence; the
 * local event makes its canonical message visible without a refetch.
 */
export const ensureTaskSelectionPrompt = async (
  projectId: string,
  phaseId: string,
  sessionId?: string | null,
): Promise<TaskSelectionPromptResponse> => {
  const response = await buildPhaseService.ensureTaskSelectionPrompt(
    projectId,
    phaseId,
    createActionInvocationId(),
    sessionId,
  );

  if (response.message) {
    eventService.emit('chat_message', {
      type: 'chat_message',
      ...response.message,
    });
  }
  scheduleTaskSelectionActionReveal(response.entry_id);

  return response;
};
